import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import {
  clearServiceProviders,
  loadServiceProviders,
} from 'redux/serviceProviders/actions';
import {
  loadServiceProvidersPendingSelector,
  serviceProvidersSelector,
} from 'redux/serviceProviders/selectors';

import immutableToJS from 'utils/immutableToJS';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    serviceProviders: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
      }),
    ).isRequired,
    loadServiceProviders: PropTypes.func.isRequired,
  };

  function mapStateToProps(state) {
    return {
      serviceProviders: serviceProvidersSelector(state),
      serviceProvidersPending: loadServiceProvidersPendingSelector(state),
    };
  }

  function mapDispatchToProps(dispatch) {
    return {
      loadServiceProviders: query => dispatch(loadServiceProviders(query)),
      clearServiceProviders: () => dispatch(clearServiceProviders()),
    };
  }

  return compose(
    setDisplayName('ServiceProviderSelectionStepContainer'),
    connect(mapStateToProps, mapDispatchToProps),
    immutableToJS,
  )(Container);
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/ServiceProviderSelectionStep/Container.js